(function () {
  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function parseVariantId(cartAddEl) {
    var explicit = cartAddEl.getAttribute('xo-variant-id');
    if (explicit) return explicit;

    var productEl = cartAddEl.closest('xo-product');
    if (!productEl) return null;

    var selected = productEl.getAttribute('xo-selected-or-first-available-variant-id');
    if (selected) return selected;

    var dataScript = productEl.querySelector('xo-product-data script');
    if (!dataScript) return null;

    try {
      var data = JSON.parse(dataScript.textContent);
      if (!data.variants || !data.variants.length) return null;
      var available = data.variants.find(function (variant) {
        return variant.available;
      });
      return String((available || data.variants[0]).id);
    } catch (error) {
      return null;
    }
  }

  function getCartSectionIds() {
    var cartMiniEl = document.querySelector('xo-cart-mini');
    var cartMiniId = cartMiniEl && cartMiniEl.id ? cartMiniEl.id : 'xo-cart-mini';
    var cartEl = document.querySelector('xo-cart');

    if (window.location.pathname.indexOf('/cart') !== -1 && cartEl && cartEl.id) {
      return [cartEl.id, cartMiniId];
    }

    return [cartMiniId];
  }

  function openCartDrawer() {
    var trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (trigger) trigger.click();
  }

  function syncCartState(cart, addData, variantId) {
    if (!window.xoStore) return;

    window.xoStore.set('xo-cart', function (prevState) {
      return Object.assign({}, prevState, {
        size: cart.item_count,
        sections: (addData && addData.sections) || prevState.sections,
        item: addData || prevState.item,
        addIdLoading: '',
        addErrorMessage: '',
        isAdded: true,
        variantId: String(variantId),
        productIdsForCartNotification: [String((addData && addData.id) || variantId)],
      });
    })('xo-cart/addCartSuccess');
  }

  function updateCartBadge(cart) {
    document.querySelectorAll('xo-cart-size').forEach(function (el) {
      el.textContent = String(cart.item_count);
    });
    document.querySelectorAll('.mevlana-header__cart-total').forEach(function (el) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        el.textContent = window.Shopify.formatMoney(cart.total_price);
      }
    });
  }

  function enableQuickAddButtons() {
    document.querySelectorAll('.xo-product-card xo-cart-add button[disabled]').forEach(function (button) {
      var cartAdd = button.closest('xo-cart-add');
      if (!cartAdd) return;
      if (cartAdd.hasAttribute('xo-disabled') && cartAdd.getAttribute('xo-disabled') !== 'false') return;
      button.removeAttribute('disabled');
    });
  }

  async function addVariantToCart(variantId, productId) {
    var formData = new FormData();
    formData.append('form_type', 'product');
    formData.append('utf8', '\u2713');
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    if (productId) formData.append('product-id', String(productId));
    formData.append('sections', getCartSectionIds().join(','));
    formData.append('section_url', window.location.pathname);

    var response = await fetch(routesRoot() + 'cart/add', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    var data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    return data;
  }

  document.addEventListener(
    'click',
    async function (event) {
      var button = event.target.closest('.xo-product-card xo-cart-add button, .xo-product-card xo-cart-add .xo-btn');
      if (!button) return;

      var cartAdd = button.closest('xo-cart-add');
      if (!cartAdd || cartAdd.closest('.xo-cart-mini-item, xo-cart-mini')) return;
      if (cartAdd.hasAttribute('xo-disabled') && cartAdd.getAttribute('xo-disabled') !== 'false') return;

      var variantId = parseVariantId(cartAdd);
      if (!variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.disabled) button.disabled = false;

      var productId = cartAdd.getAttribute('xo-product-id');
      button.classList.add('xo-btn--loading');
      try {
        var addData = await addVariantToCart(variantId, productId);
        var cartResponse = await fetch(routesRoot() + 'cart.js');
        var cart = await cartResponse.json();
        syncCartState(cart, addData, variantId);
        updateCartBadge(cart);
        openCartDrawer();
      } catch (error) {
        console.error('[Mevlana quick add]', error);
      } finally {
        button.classList.remove('xo-btn--loading');
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableQuickAddButtons);
  } else {
    enableQuickAddButtons();
  }

  document.addEventListener('shopify:section:load', enableQuickAddButtons);
})();
